module.exports = __webpack_public_path__ + "img/ic_capture_patient.edc9d692.svg";